var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessLevelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    stroke: "#D2D2D9",
    strokeWidth: 2.75,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEF0F3",
    width: 79.13,
    height: 18.261,
    rx: 6.087
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 60.87,
    y: 73.043,
    width: 79.13,
    height: 18.261,
    rx: 6.087
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EEF0F3",
    x: 60.87,
    y: 121.739,
    width: 79.13,
    height: 18.261,
    rx: 6.087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.478 91.304v30.435M42.609 18.267v27.391a9.13 9.13 0 0 0 9.13 9.13h42.609a9.13 9.13 0 0 1 9.13 9.131v9.13"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessLevelIcon);
export default __webpack_public_path__ + "static/media/access-level-icon.a03d6e9d663cd41b8e1847f08903f8fb.svg";
export { ForwardRef as ReactComponent };